import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Heading, Text } from 'components/common/Elements/Elements';

import classes from './Csat.module.scss';

const Csat = ({ data: { title = '', contentText = {} } = {} }) => {
  const { csatChatScore, csatTicketScore, csatTicketsCount, csatChatsCount } =
    contentText;
  return (
    <section className={classes.box}>
      <Heading className={classes.title}>{title}</Heading>
      <div className={classes.wrapInfo}>
        <div className={cn(classes.info, classes.info_yellow)}>
          <Text type="p" className={classes.textWrap}>
            <Text weight="b" className={classes.headingInfo}>
              Tickets
            </Text>
            <Text className={classes.text} weight="b">
              {csatTicketScore}
            </Text>
          </Text>
          <Text type="p" className={classes.textWrap}>
            <Text weight="r" className={classes.headingInfo}>
              Total Tickets
            </Text>
            <Text className={classes.total} weight={'b'}>
              {csatTicketsCount}
            </Text>
          </Text>
        </div>
        <div className={cn(classes.info, classes.info_blue)}>
          <Text type="p" className={classes.textWrap}>
            <Text weight="b" className={classes.headingInfo}>
              Chats
            </Text>
            <Text className={classes.text} weight="b">
              {csatChatScore}
            </Text>
          </Text>
          <Text type="p" className={classes.textWrap}>
            <Text weight="r" className={classes.headingInfo}>
              Total Chats
            </Text>
            <Text className={classes.total} weight="b">
              {csatChatsCount}
            </Text>
          </Text>
        </div>
      </div>
    </section>
  );
};

Csat.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    contentText: PropTypes.shape({
      csatChatScore: PropTypes.string,
      csatTicketScore: PropTypes.string,
      csatTicketsCount: PropTypes.string,
      csatChatsCount: PropTypes.string
    })
  })
};

export default Csat;
